const Translation = {
  invite_users: "Invitar usuarios",
  send_invite: "Enviar invitación",
  save_details: "Guardar detalles",
  email: "Correo electrónico",
  mobile: "Web/App",
  role: "Rol",
  error_email_required: "El correo electrónico es obligatorio",
  error_valid_email: "El correo electrónico no es válido",
  error_role_required: "El rol es obligatorio",
  error_firstName_required: "El nombre es obligatorio",
  error_access_point_required: "El punto de acceso es obligatorio",
  error_something_went_wrong: "Algo salió mal",
  invite_success: "Invitación enviada con éxito",
  error_login_again:
    "El token de inicio de sesión ha expirado. Por favor inicia sesión nuevamente.",
  access_denied: "Acceso denegado",
  invalid_email_domain:
    "No se pueden invitar correos personales a Voyage Control. Usa un correo empresarial.",
  user_management: "Gestión de usuarios",
  add_another: "Agregar otro check-in programado",
  invite_later: "Invitar más tarde",
  close: "Cerrar",
  filter: "Filtro",
  please_select_site: "Por favor selecciona un sitio.",
  name_required: "El nombre es obligatorio",
  start_time_required: "La hora de inicio es obligatoria",
  end_time_required: "La hora de fin es obligatoria",
  select_site: "Seleccionar sitio",
  resource_operating_time: "Horario de operación de recursos",
  all_day: "Todo el día",
  breaks: "Cierre del sitio (día y hora)",
  add_break: "Agregar cierre del sitio",
  name: "Nombre",
  days_required: "Selecciona días",
  days_active: "Días",
  all_days: "Todos los días",
  all_accesspoint: "Mostrar todos los puntos de acceso",
  all_resources: "Mostrar todos los recursos",
  start_time: "Hora de inicio",
  end_time: "Hora de fin",
  resources: "Recursos",
  vehicles: "Vehículos",
  resource_required: "El recurso es obligatorio",
  cancel: "Cancelar",
  save: "Guardar",
  edit_break: "Editar cierre del sitio",
  start_time_add_required: "La hora de inicio es obligatoria",
  end_time_add_required: "La hora de fin es obligatoria",
  remove: "Eliminar",
  resource_closure: "Cierre de recursos (fecha y punto de acceso)",
  add_resource_closure: "Agregar cierre de recursos",
  edit_resource_closure: "Editar cierre de recursos",
  dates: "Fechas",
  start_date_required: "Selecciona la fecha de inicio",
  end_date_required: "Selecciona la fecha de fin",
  start_date_no_past_required: "La fecha de inicio no puede ser anterior a hoy",
  end_date_no_past_required: "La fecha de fin no puede ser anterior a hoy",
  organization_Role_updated: "El rol de la organización ha sido actualizado",
  clear_all: "Limpiar todo",
  status: "Estado",
  project_role: "Rol del proyecto",
  platform_role: "Rol de la plataforma",
  organization: "Organización",
  first_name: "Nombre",
  last_name: "Apellido",
  email_address: "Correo electrónico",
  associated_organization: "Organización",
  no_data_found: "No se encontraron datos",
  access_point: "Punto de acceso",
  access_point_required: "El punto de acceso es obligatorio",
  vehicle_type: "Tipo de vehículo",
  vehicle_type_required: "Selecciona un tipo de vehículo",
  vehicles_number_required: "El número de vehículos es obligatorio",
  resource: "Recurso",
  next: "Siguiente",
  contact_desc:
    "Para consultas, contacta a Site Super Steven (steve@sitesuper.com). Descarga la app móvil para ver el calendario.",
  full_site_plan: "Ver plano completo del sitio",
  site_plan: "Plano del sitio",
  on: " ",
  on_every: " ",
  vehicle: "Vehículo",
  vehicle_tracking: "Seguimiento de vehículos",
  select_role: "Seleccionar rol",
  please_select_time: "Selecciona una hora dentro del horario disponible",
  please_select_time_in_resource: "Selecciona una hora del recurso",
  no_resource_found: "No se encontraron recursos",
  remove_last: "Eliminar último",
  remove_vehicle: "Eliminar vehículo",
  filters: "Filtros",
  saved_details_success_fully: "Detalles guardados correctamente",
  saved_successfully: "Guardado correctamente",
  success: "Éxito",
  notifications_marked_as_read: "Notificación marcada como leída",
  notifications_marked_as_unread: "Notificación marcada como no leída",
  notifications_api_not_implemented:
    "Las notificaciones no están disponibles en este momento",
  project_site_postcode_not_available:
    "El código postal del sitio del proyecto no está disponible",
  last_name_required: "El apellido es obligatorio",
  phone_required: "El número de teléfono es obligatorio",
  invalid_phone: "Número de teléfono inválido",
  can_not_remove_project_owner:
    "No se puede eliminar al propietario del proyecto",
  details: "Detalles",
  phone_number: "Número de teléfono",
  company: "Organización",
  roles: "Roles",
  organization_role: "El rol de la organización ha sido actualizado",
  remove_user_from_project: "Eliminar usuario del proyecto",
  booking_list: "Lista de reservas",
  all: "Todos",
  go: "Ir",
  submit: "Enviar",
  submit_booking: "Enviar reserva",
  back: "Atrás",
  start: "Comenzar",
  done: "Hecho",
  Additional_Comment: "Comentario adicional",
  Comment: "Comentario",
  company_name_required: "El nombre de la organización es obligatorio",
  full_name_is_required: "El nombre completo es obligatorio",
  email_not_valid: "Correo electrónico inválido",
  email_required: "El correo electrónico es obligatorio",
  mobile_number_required: "El número de teléfono es obligatorio",
  mobile_number_not_valid: "Número de teléfono inválido",
  site_contact: "Contacto del sitio",
  booking_contact: "Contacto de reserva",
  company_name: "Nombre de la organización",
  full_name: "Nombre completo",
  email_Address: "Correo electrónico",
  Mobile_number: "Número de teléfono",
  use_my_details: "Usar mis datos",
  select_options: "Selecciona opciones",
  text_field_required: "El campo de texto es obligatorio",
  checkbox_required: "La casilla es obligatoria",
  file_upload_required: "La subida de archivo es obligatoria",
  comments_required: "El comentario es obligatorio",
  please_select_time_slot: "Selecciona un horario",
  Hours: "Horas",
  Minutes: "Minutos",
  Maximum: "Máximo",
  Minimum: "Mínimo",
  booking: "Reserva",
  Get_Slots: "Actualizar horarios",
  booking_which_time_on: "Seleccionar horario de reserva",
  Show_more_time_slots: "Mostrar más horarios",
  Afternoon: "Tarde",
  Evening: "Noche",
  Morning: "Mañana",
  comments: "Comentarios",
  title: "Título",
  phone: "Teléfono",
  question: "Pregunta",
  file_uploaded: "Archivo subido correctamente",
  file_upload_success: "Archivo subido correctamente",
  file_upload_failed: "Error al subir el archivo",
  files: "Archivos",
  upload_new_file: "Subir nuevo archivo",
  no_notes: "No hay notas",
  no_options: "No hay opciones",
  no_files: "No hay archivos",
  no_notes_displayed: "Las notas aparecerán aquí",
  no_files_displayed: "Los archivos aparecerán aquí",
  add_note: "Agregar nota",
  action: "Acción",
  action_by: "Acción realizada por",
  show_linked_recurring: "Mostrar reservas recurrentes vinculadas",
  For_Approval: "Pendiente de aprobación",
  Scheduled: "Aprobado",
  Checked_In: "Registrado",
  Checked_out: "Salida registrada",
  Declined: "Rechazado",
  Cancelled: "Cancelado",
  Refused: "Entrada rechazada",
  cant_undo: "Esta acción no se puede deshacer",
  are_you_sure: "¿Estás seguro?",
  are_you_sure_cancel_booking: "¿Seguro que deseas cancelar esta reserva?",
  are_you_sure_cancel_all_booking:
    "¿Seguro que deseas cancelar todas las reservas?",
  are_you_sure_decline_booking: "¿Seguro que deseas rechazar esta reserva?",
  yes: "Sí",
  no: "No",
  linked_booking: "Reservas recurrentes",
  notification_preference: "Preferencias de notificación",
  my_booking_content:
    "Aquí puedes configurar las notificaciones de tus reservas.",
  my_org_booking_content:
    "Aquí puedes configurar notificaciones de reservas de tu organización.",
  all_project_booking_content:
    "Aquí puedes configurar notificaciones de todas las reservas del proyecto.",
  save_changes: "Guardar cambios",
  to_all_recurring: "Todas las reservas",
  this_only: "Solo esta reserva",
  part_of_recurring_decline:
    "Esta reserva es parte de una serie. ¿Rechazar solo esta o todas?",
  part_of_recurring_approve:
    "Esta reserva es parte de una serie. ¿Aprobar solo esta o todas?",
  part_of_recurring_cancel:
    "Esta reserva es parte de una serie. ¿Cancelar solo esta o todas?",
  part_of_recurring_edit:
    "Esta reserva es parte de una serie. ¿Editar solo esta o todas?",
  edit: "Editar",
  edit_this_booking: "Editar esta reserva",
  move: "Cambiar fecha y hora",
  download_pass: "Descargar pase de entrada/salida",
  expected_vehicles: "Número esperado de check-ins",
  scheduling_information: "Información de programación",
  scheduling_information_tooltip:
    "Si faltan datos requeridos para las opciones, puedes modificarlos en la sección de gestión del proyecto o contactar al administrador del proyecto.",
  okay: "OK",
  collapse: "Colapsar",
  required_text_indication_text: "Los campos marcados con * son obligatorios",
  required_save_changes_text:
    'Si realizas cambios, asegúrate de hacer clic en "Guardar cambios" para aplicarlos.',
  check_in_time: "Hora de check-in",
  check_out_time: "Hora de check-out",
  cancel_booking: "Cancelar reserva",
  cancel_all_booking: "Cancelar todas las reservas",
  decline_booking: "Rechazar reserva",
  edit_booking_details: "Editar detalles de la reserva",
  booking_details: "Contacto",
  additional_details: "Detalles adicionales",
  preference_updated_successfully: "Preferencias actualizadas correctamente",
  automatic_approved: "Aprobado automáticamente",
  you_are_admin: "Eres administrador de la organización",
  new_booking: "Nueva reserva",
  edit_booking: "Editar reserva",
  select_country: "Seleccionar país",
  required_country: "El país es obligatorio",
  country: "País",
  confirm_move_booking: "Cambiar fecha y hora de la reserva",
  current_date_slot: "Fecha actual de la reserva",
  current_time_slot: "Hora actual de la reserva",
  move_which_time_on: "Nueva fecha y hora",
  show_more_slot: "Mostrar más horarios",
  move_booking: "Confirmar",
  remove_user_confirm: "¿Estás seguro de eliminar este usuario?",
  page: "Seleccionar página",
  join_company: "Unirse a la organización",
  log_into: "Iniciar sesión",
  dont_recognize_company: "Esta organización no es reconocida",
  units: "Unidades",
  export_tooltip_message:
    "Al exportar, la descarga comenzará automáticamente cuando esté lista. También recibirás un enlace por correo electrónico.",
  select_booking: "Debes seleccionar un tipo de reserva para continuar",
  what_kind_of_booking: "Selecciona el tipo de reserva",
  expected_number_vehicle: "Número esperado de check-ins",
  email_us: "Contáctanos por correo",
  please_contact_us: "Por favor contáctanos",
  previous: "Anterior",
  please_select_slot: "Selecciona un horario",
  please_select_date: "Selecciona una fecha",
  booking_moved: "La reserva ha sido reprogramada",
  calendar_captured: "Calendario capturado correctamente",
  booking_edited: "La reserva ha sido editada",
  logout: "Cerrar sesión",
  help: "Ayuda",
  none: "Ninguno",
  created_by: "Creado por",
  hours_restricted_tooltip_text:
    "Los usuarios no podrán reservar dentro del tiempo límite desde el momento actual.",
  days_allowed_in_advance_tooltip_text:
    "Los usuarios solo pueden reservar dentro del rango de días permitido desde hoy.",
  admin_portal: "Portal de administrador",
  coming_soon: "Próximamente",
  project_name: "Nombre del proyecto",
  create_account: "Crear cuenta",
  time_left_complete_booking: "Tiempo restante para completar la reserva",
  reselect_timeslot: "Seleccionar nuevamente el horario",
  calendar: "Calendario",
  mine: "Mío",
  time: "Hora",
  booking_type: "Tipo de reserva",
  contact_org: "Contacto de la organización",
  resource_availability_updated: "Disponibilidad de recursos actualizada",
  week: "Semana",
  day: "Día",
  show_weekends: "Mostrar fines de semana",
  show_canceled_and_declined: "Mostrar reservas canceladas y rechazadas",
  today: "Hoy",
  loading_availability: "Cargando disponibilidad...",
  cant_move_on_unavailable_timeslot:
    "No se puede mover a un horario no disponible",
  no_slot_available: "No hay horarios disponibles",
  you_dont_have_permission: "No tienes permiso para acceder a esta reserva",
  no_common_dates_for_resources:
    "No hay fechas comunes para los recursos seleccionados",
  no_common_slots_for_resources:
    "No hay franjas horarias comunes para los recursos seleccionados",
  slot_is_not_available: "La franja horaria no está disponible",
  error_start_date_required: "La fecha de inicio es obligatoria",
  vehicle_restriction_added: "Restricción de vehículo agregada correctamente",
  vehicle_restriction_removed: "Restricción de vehículo eliminada correctamente",
  cant_booking_cause: "Razón por la cual no se puede mover la reserva",
  you_dont_have_permission_for_move_booking:
    "No tienes permiso para mover esta reserva",
  cant_move_booking_in_past: "No puedes mover la reserva a una fecha pasada",
  max_unit_should_not_negative: "El valor debe ser mayor o igual a 0",
  please_enter_max_quantity: "Introduce la cantidad máxima",
  please_select_project: "Selecciona un proyecto",
  replace: "Reemplazar",
  number_of_days_booking_label: "Días permitidos para reserva",
  number_of_hours_booking_label: "Tiempo límite (h)",
  advance_booking: "Restricciones de reserva",
  error_end_date_required: "La fecha de fin es obligatoria",
  error_star_date_required: "La fecha de inicio es obligatoria",
  error_field_required: "Este campo es obligatorio",
  success_response_site_availability:
    "Disponibilidad actualizada correctamente",
  hours_of_operation: "Horario de operación",
  break: "Cierre del sitio",
  error_name_required: "El nombre es obligatorio",
  error_starttime_required: "La hora de inicio es obligatoria",
  error_end_time_required: "La hora de fin es obligatoria",
  day_active: "Días activos",
  site_closure: "Cierre del sitio",
  add_site_closure: "Agregar cierre del sitio",
  edit_site_closure: "Editar cierre del sitio",
  error_message_site_availability: "Selecciona horario de operación",
  error_message_availability: "Selecciona horario de recurso",
  to: "a",
  please_select_days: "Selecciona días",
  make_booking_info_message: "Mensaje mostrado en la pantalla de reserva",
  welcome_text: "Bienvenido a Voyage Control",
  pls_login: "Por favor inicia sesión",
  password: "Contraseña",
  forgot_password: "¿Olvidaste tu contraseña?",
  login: "Iniciar sesión",
  check_info: "Verificando información",
  success_message: "Inicio de sesión exitoso",
  error_password_required: "La nueva contraseña es obligatoria",
  error_valid_password: "La contraseña no es válida",
  comman_error_message:
    "No existe una cuenta con este correo. Contacta al administrador.",
  reset_password: "Restablecer contraseña",
  welcometext_reset: "La contraseña debe tener al menos 8 caracteres",
  confirmpassword: "Confirmar contraseña",
  error_confirm_password_required: "Confirmar contraseña es obligatorio",
  error_password_upper: "Debe contener al menos una mayúscula",
  error_password_lower: "Debe contener al menos una minúscula",
  error_password_number: "Debe contener al menos un número",
  error_password_special: "Debe contener al menos un carácter especial",
  error_password_min: "Mínimo 8 caracteres",
  error_password_max: "Máximo 16 caracteres",
  error_password_not_match: "Las contraseñas no coinciden",
  backtologin: "Volver al inicio de sesión",
  welcometext_forgot: "Introduce tu correo para recibir instrucciones",
  set_your_company: "Configurar empresa",
  companyname: "Nombre de la empresa",
  address1: "Dirección 1",
  address2: "Dirección 2",
  town_city: "Ciudad",
  zip_code: "Código postal",
  company_success_message: "Te has unido a la organización",
  error_companyname_required: "El nombre es obligatorio",
  error_address_required: "La dirección es obligatoria",
  error_country_required: "El país es obligatorio",
  profile_welcome_text: "Configurar perfil",
  firstname: "Nombre",
  lastname: "Apellido",
  phoneNumber: "Teléfono",
  error_firstname_required: "El nombre es obligatorio",
  error_lastname_required: "El apellido es obligatorio",
  error_phonenumber_required: "El teléfono es obligatorio",
  error_valid_phonenumber: "Número inválido",
  details_saved: "Configuración guardada",
  my_account: "Mi cuenta",
  my_details: "Mis datos",
  update_password: "Actualizar contraseña",
  my_preferences: "Preferencias",
  calendar_start_day: "Día de inicio del calendario",
  my_roles: "Roles",
  added_contact: "Contacto añadido",
  deleted_contact: "Contacto eliminado",
  upload: "Subir",
  pls_Signup: "Regístrate",
  createaccount: "Crear cuenta",
  org_role: "Rol de organización",
  choose_project: "Elegir proyecto",
  this_project_only: "Solo este proyecto",
  user_removed: "Usuario eliminado",
  org_role_updated: "Rol actualizado",
  no_user_found: "No se encontraron usuarios",
  current_password: "Contraseña actual",
  new_password: "Nueva contraseña",
  new_password_again: "Confirmar nueva contraseña",
  current_password_is_required: "La contraseña actual es obligatoria",
  org_success_message: "Datos de la organización actualizados",
  error_organization_name_required: "Nombre obligatorio",
  error_organization_address1_required: "Dirección obligatoria",
  error_organization_address2_required: "Dirección obligatoria",
  error_organizationTown_required: "Ciudad obligatoria",
  error_organizationZip_required: "Código postal obligatorio",
  error_organizationLogo_required: "Logo obligatorio",
  error_organizationLogo_invalid: "Archivo inválido",
  organization_details: "Detalles de la organización",
  trade_type: "Tipo de negocio",
  select_trade_type: "Selecciona tipo de negocio",
  organization_logo: "Logo de la organización",
  error_no_white_space: "No se permiten espacios",
  password_length_range: "8–16 caracteres",
  enter_valid_password: "Introduce una contraseña válida",
  details_heading_text: "Detalles",
  details_image_text: "Imagen",
  label_sitename: "Nombre del sitio",
  label_siteadd: "Dirección del sitio",
  label_logo: "Logo",
  label_home_banner: "Banner",
  label_home_screen_message: "Mensaje de inicio",
  error_image_invalid: "Imagen inválida",
  error_siteLogo_required: "Logo requerido",
  error_homebanner_required: "Banner requerido",
  error_sitename_required: "Nombre requerido",
  error_siteadd_required: "Dirección requerida",
  error_homemessage_required: "Mensaje requerido",
  contact_heading_text: "Contacto",
  add_contact: "Agregar contacto",
  edit_contact: "Editar contacto",
  label_name: "Nombre",
  label_position: "Cargo",
  label_phone: "Teléfono (opcional)",
  btn_add: "Agregar",
  btn_remove: "Eliminar",
  btn_edit: "Guardar",
  btn_save: "Guardar",
  change_associated_organization: "Cambiar organización",
  confirm: "Confirmar",
  new_organization: "Nueva organización",
  changed_organization: "Organización cambiada correctamente",
  changed_organization_no_role:
    "Este usuario no tiene ningún rol en la organización seleccionada",
  changed_organization_tooltip:
    "Puedes cambiar la organización desde el menú de usuario",
  error_position_required: "Cargo obligatorio",
  resourse_add: "Recurso añadido",
  vehicle_list_updated: "Lista de vehículos actualizada",
  resource_remove: "Recurso eliminado",
  resource_edit: "Recurso actualizado",
  access_point_heading_text: "Punto de acceso",
  btn_cancel: "Cancelar",
  btn_GO: "Ir",
  add_access_point: "Agregar punto de acceso",
  edit_access_point: "Editar punto de acceso",
  label_maxUnit: "Capacidad",
  error_MaxUnit_required: "Capacidad obligatoria",
  error_MaxUnit_not_negative_number: "Debe ser >= 0",
  no_data_found_error: "No se encontraron puntos de acceso",
  no_available_flex_forms: "No hay formularios disponibles",
  add_response_message: "Punto añadido",
  edit_response_message: "Punto editado",
  delete_response_message: "Punto eliminado",
  resource_heading_text: "Recursos",
  vehicles_heading_text: "Vehículos",
  resource_text: "Recurso",
  accesspoint_text: "Punto de acceso",
  maxqty_text: "Cantidad",
  active_text: "Activo",
  account_success_message: "Cuenta actualizada",
  error_Phone_required: "Teléfono obligatorio",
  error_dateformat_required: "Formato de fecha obligatorio",
  error_language_required: "Idioma obligatorio",
  error_timeformat_invalid: "Formato inválido",
  error_startday_required: "Día de inicio obligatorio",
  error_Phone_invalid: "Teléfono inválido",
  error_email_invalid: "Correo inválido",
  apply_filter: "Aplicar filtro",
  login_again: "Sesión expirada. Inicia sesión nuevamente",
  something_went_wrong: "Algo salió mal",
  booking_created: "Reserva creada",
  booking_updated: "Reserva actualizada",
  booking_approved_success: "Reserva aprobada correctamente",
  booking_declined_success: "Reserva rechazada correctamente",
  booking_cancelled_success: "Reserva cancelada correctamente",
  booking_checked_in_success: "Entrada de la reserva registrada correctamente",
  booking_checked_out_success: "Salida de la reserva registrada correctamente",
  booking_refused_success: "Reserva denegada correctamente",
  booking_reinstated_success: "Reserva restablecida correctamente",
  booking_status_updated_success:
    "Estado de la reserva actualizado correctamente",
  bulk_action_partial_success:
    "{{succeeded}} de {{total}} reservas actualizadas, {{failed}} con errores",
  booking_note_added_success: "Nota agregada correctamente",
  thank_you_for_booking_your_delivery_into: "Gracias por tu reserva",
  description: "La reserva está pendiente de aprobación.",
  summary: "Resumen",
  booking_id: "ID de reserva",
  date: "Fecha",
  go_to_list_view: "Ir a lista",
  make_another_booking: "Hacer otra reserva",
  take_a_note: "Ten en cuenta las reglas del sitio",
  ppe_worn: "Usa PPE en todo momento",
  vehicle_not_allowed: "Vehículos sin chaleco no pueden entrar",
  priority: "Prioridad a vehículos puntuales",
  see_all: "Ver más",
  see_less: "Ver menos",
  scheduled: "Programado",
  repeats: "Repeticiones",
  anticipated_no_check_ins: "Check-ins estimados",
  start_date_is_required: "Selecciona fecha inicio",
  end_date_is_required: "Selecciona fecha fin",
  select_day: "Selecciona día",
  date_is_required: "Fecha requerida",
  choose_date: "Elegir fecha",
  choose_start_date: "Elegir inicio",
  choose_end_date: "Elegir fin",
  repeat_every: "Repetir cada",
  repeat_type_required: "Tipo requerido",
  repeat_on: "Repetir en",
  month_week_required: "Semana requerida",
  month_day_required: "Día requerido",
  check_in: "Check-in",
  check_out: "Check-out",
  refuse_entry: "Rechazar entrada",
  checkout_desc: "Check-out completado",
  booking_refused_desc: "Entrada rechazada",
  booking_decline_desc: "Reserva rechazada",
  cancel_desc: "Reserva cancelada",
  approve: "Aprobar",
  reschedule: "Reprogramar",
  decline: "Rechazar",
  drag_and_drop: "Arrastra y suelta el archivo",
  browse_file: "Seleccionar archivo",
  welcome_to: "Bienvenido",
  project_management: "Gestión de proyectos",
  project_details: "Detalles del proyecto",
  availibility: "Configuración de reservas",
  my_organization: "Configuración de la organización",
  notification_preferences: "Preferencias de notificación",
  language: "Idioma",
  date_format: "Formato de fecha",
  time_format: "Formato de hora",
  users: "Usuarios",
  no_resource_available_for_access_point:
    "No hay recursos disponibles en este punto de acceso",
  project_setting: "Configuración del proyecto",

  procore_disconnected_alert_title: "No autenticado",
  procore_disconnect_action: "Desconectar de Procore",
  procore_connect_action: "Conectar con Procore",
  procore_connected_alert_title: "Autenticado",
  procore_connected_alert:
    "La integración de Procore está conectada a tu cuenta de Procore.",
  procore_status_change_success:
    "El estado de la integración de Procore se actualizó correctamente.",
  procore_status_change_error:
    "Error al actualizar el estado de la integración. Contacta al administrador.",

  procore_connection_desc:
    "Al conectar Voyage Control con un proyecto de Procore, puedes usar funciones adicionales como registrar entregas en el Daily Log de Procore.",

  edit_integration: "Editar integración",

  procore_login_info_message:
    "Se requieren credenciales de Procore. Instala la app Voyage Control desde el marketplace de Procore. Puede que necesites habilitar permisos adicionales.",

  connect: "Conectar",
  disconnect: "Desconectar",

  project: "Proyecto",

  confirm_disconnect_message: "¿Seguro que deseas desconectar de Procore?",
  disconnecting_cause_feature_not_working:
    "Al desconectar de Procore, algunas funciones podrían dejar de estar disponibles.",

  additional_features: "Funciones adicionales",
  automatic_approvals: "Aprobación automática",
  automatic_approvals_details:
    "Todas las reservas se aprueban automáticamente al crearse.",

  log_action_to_daily_log: "Registrar acciones en el Daily Log de Procore",
  log_action_to_daily_log_detail:
    "Cada acción realizada en una reserva se registrará en el Daily Log de Procore. Requiere configuración de integración.",

  edit_actions: "Configuración",
  choose_booking_action: "Seleccionar acción de reserva",
  choose_booking_action_detail:
    "Las acciones seleccionadas se registrarán en el Daily Log de Procore.",

  Edited: "Editado",
  Moved: "Cambio de fecha/hora",

  pending_approval: "Pendiente de aprobación",
  approved: "Aprobado",

  checked_in_multi_vehicle: "Check-in (múltiples vehículos)",
  refused_multi_vehicle: "Entrada rechazada (múltiples vehículos)",
  checked_out_multi_vehicle: "Check-out (múltiples vehículos)",

  booking_ref: "ID de reserva",
  arrival_date: "Fecha prevista",
  arrival_time: "Hora de entrada",
  departure_time: "Hora de salida",

  contact_company: "Empresa de contacto",
  creator_company: "Empresa del solicitante",
  recurring: "Reserva recurrente",
  delivery: "Reserva estándar",
  Van: "Furgoneta",
  Car: "Coche",
  Other: "Otro",
  Tanker: "Camión cisterna",

  "For Approval": "Pendiente",
  "Checked out": "Check-out",
  "Checked In": "Check-in",

  "multi-vehicle": "Múltiples vehículos",
  "resource-only": "Solo recursos",

  "18 Wheeler": "Camión de 18 ruedas",
  "Box Truck": "Camión cerrado",
  "Flatbed Truck": "Camión plataforma",
  "Dump Truck": "Camión volquete",
  "Mobile Crane": "Grúa móvil",
  "Pickup Truck": "Camioneta pickup",
  my_bookings: "Mis reservas",
  my_org_bookings: "Reservas de mi organización",
  all_project_bookings: "Todas las reservas",
  Active: "Activo",
  Inactive: "Inactivo",
  Invited: "Invitado",
  Restricted: "Restringido",
  Blocked: "Bloqueado",
  "Project Admin": "Administrador del proyecto",
  "Project Manager": "Gerente de proyecto",
  "Project Owner": "Propietario del proyecto",
  "Project User": "Usuario del proyecto",
  verified_domains: "Dominios verificados",
  email_domain: "Dominio de correo",
  project_information: "Información del proyecto",
  site: "Sitio",
  availability: "Configuración de reservas",
  unlimited: "Sin límite",
  Sunday: "Domingo",
  Monday: "Lunes",
  Tuesday: "Martes",
  Wednesday: "Miércoles",
  Thursday: "Jueves",
  Friday: "Viernes",
  Saturday: "Sábado",
  Sun: "Dom",
  Mon: "Lun",
  Tue: "Mar",
  Wed: "Mié",
  Thu: "Jue",
  Fri: "Vie",
  Sat: "Sáb",
  settings: "Configuración",
  integrations: "Integraciones",
  select: "Seleccionar",
  from: "Desde",
  booking_information: "Información de la reserva",
  activity: "Actividad",
  notes: "Notas",
  January: "Enero",
  February: "Febrero",
  March: "Marzo",
  April: "Abril",
  May: "Mayo",
  June: "Junio",
  July: "Julio",
  August: "Agosto",
  September: "Septiembre",
  October: "Octubre",
  November: "Noviembre",
  December: "Diciembre",
  site_detail_tooltip:
    "Por favor, introduzca el nombre del proyecto y la dirección del sitio. La información configurada aquí se mostrará en la página principal.",
  project_address_tooltip:
    "Introduzca la dirección del sitio o seleccione cualquier ubicación en el mapa.",
  home_screen_message_tooltip:
    "El mensaje escrito aquí se mostrará en la página principal.",
  project_logo_tooltip:
    "Si carga el logotipo del proyecto, se mostrará en la página principal del proyecto y en varias otras áreas dentro de este sistema.",
  project_banner_tooltip:
    "Por favor, cargue la imagen del banner de la página principal.",
  project_information_contact_tooltip:
    "Añada la información de contacto del principal responsable del sitio. Los contactos añadidos aquí se mostrarán en la página principal.",
  information_accesspoint_tooltip:
    "Configure las puertas de entrada y salida del sitio (nombre y capacidad de la puerta). Debe configurar al menos una puerta.",
  max_unit_tooltip:
    "Es la cantidad máxima que se puede reservar en la misma franja horaria.",
  information_resource_tooltip:
    "En los recursos internos del sitio, configure equipos utilizados en la obra como grúas, polipastos y montacargas.",
  information_vehicle_tooltip:
    "En esta sección del sitio, puede especificar la disponibilidad y solicitudes de vehículos para crear reservas en el proyecto. Cada proyecto debe incluir al menos un tipo de vehículo disponible.",
  resource_access_point_tooltip:
    "Seleccione la puerta de entrada/salida donde se puede utilizar este recurso interno.",
  resource_max_quantity_tooltip:
    "Es la cantidad máxima de este recurso interno que se puede utilizar al mismo tiempo.",
  site_hours_of_operation_tooltip:
    "Configure el horario de funcionamiento del sitio. Los usuarios podrán solicitar reservas dentro del horario configurado aquí. Si activa la casilla [Todo el día], los usuarios podrán reservar las 24 horas.",
  site_breaks_tooltip:
    "Los usuarios no podrán solicitar reservas en los días y horarios configurados.",
  site_closure_tooltip:
    "En fechas específicas y puertas de entrada/salida configuradas, los usuarios no podrán solicitar reservas. Se recomienda configurarlo para festivos o vacaciones prolongadas.",
  site_booking_creation_message_tooltip:
    "El mensaje escrito aquí se mostrará al solicitar una reserva.",
  site_plan_tooltip:
    "Al cargar el mapa del sitio (plano de distribución), los usuarios podrán consultarlo al solicitar una reserva.",
  resource_operating_time_tooltip:
    "Configure los días y horarios en los que se puede reservar este recurso interno. Los usuarios podrán solicitar reservas para usar el recurso dentro del horario configurado. Si activa la casilla [Todo el día], podrán reservar las 24 horas.",
  resource_closure_tooltip:
    "En las fechas configuradas, los usuarios no podrán solicitar reservas para utilizar este recurso interno.",
  booking_duration_tooltip:
    "Seleccione el tiempo estimado de carga/descarga. Si está solicitando una reserva con múltiples entradas y salidas, seleccione el tiempo estimado en que todos los vehículos completarán la carga/descarga.",
  duration_hrs: "Duración",
  booking_date: "Fecha",
  booking_time: "Hora",
  Weekly: "Semanal",
  Monthly: "Mensual",
  First: "Primero",
  Last: "Último",
  a_password_must_contain:
    "La contraseña debe cumplir con las siguientes condiciones",
  organization_updated_successfully:
    "Los detalles de la organización se han actualizado correctamente",
  "This field is required.": "Este campo es obligatorio",
  contact_edit_successfully: "Contacto editado con éxito",
  please_check_your_email: "Por favor, revisa tu correo electrónico",
  for_reset_password: "Para restablecer la contraseña",
  disable_procore_info_tooltip:
    "Las funciones Pro no están habilitadas en este proyecto. Si estás interesado en esta función, contacta con tu gestor de cuenta o el equipo de ventas (sales@voyagecontrol.com).",
  procore_company_and_project_updated:
    "La empresa y el proyecto de Procore se actualizaron correctamente",
  daily_log_action_updated_for_booking_status:
    "La acción del registro diario para el estado de la reserva se actualizó correctamente",
  disconnected_daily_log_action:
    "La acción del registro diario ha sido desconectada",
  disconnected_procore: "Desconectado de Procore",
  connected_daily_log_action: "La acción del registro diario está conectada",
  invite_from_procore: "Invitar desde Procore",
  please_select_user: "Por favor, selecciona al menos un usuario",
  procore_unauthorize: "Error de autenticación",
  procore_authorize: "Autenticación exitosa",
  error_procore_redirect:
    "La integración no está activa en este proyecto. Por favor, contacta con el administrador",
  selected: "Seleccionado",
  print: "Imprimir",
  column_config: "Configuración de visualización de la lista de reservas",
  new_layout: "Crear nuevo diseño",
  select_column: "Seleccionar columnas",
  column_order: "Orden de columnas",
  by_access_point: "Por punto de acceso",
  by_resource: "Por recurso",
  label_M: "L",
  label_TUE: "M",
  label_W: "X",
  label_THU: "J",
  label_F: "V",
  label_SA: "S",
  label_SU: "D",
  hour: "Hora",
  minute: "Minuto máximo",
  admin: "Permisos de la organización",

  "Security Guard": "Guardia de seguridad",
  "View Only": "Solo lectura",
  "Project Senior User": "Usuario senior del proyecto",
  Auth_err_email_not_found:
    "Esta cuenta no es válida. Por favor, contacta con el administrador del proyecto.",
  Auth_err_invalid_token: "Token inválido",
  Auth_err_missing_credentials: "Faltan credenciales de autenticación",
  Auth_err_no_active_account: "Nombre de usuario o contraseña incorrectos",
  Auth_err_no_active_user:
    "No se encontró una cuenta con este correo electrónico",
  Auth_err_project_already_exists: "Este proyecto ya existe",
  Auth_err_similar_password: "La nueva contraseña es igual a la actual",
  Auth_err_validating_old_password: "La contraseña actual es incorrecta",
  Auth_msg_password_reset: "Contraseña restablecida con éxito",
  Auth_msg_user_removed_from_project: "El usuario fue eliminado del proyecto",
  Err_all_access_point_slots_booked:
    "Todos los slots del punto de acceso están reservados",
  Err_all_resource_slots_booked: "Todos los slots de recursos están reservados",
  Err_all_vehicles_cleared: "No quedan vehículos",
  Err_answer_option_invalid: "La opción especificada no es válida",
  Err_attachment_booking_mismatch:
    "Este archivo adjunto pertenece a otra reserva",
  Err_body_must_be_list: "El cuerpo debe ser una lista de objetos",
  Err_booking_can_not_be_edited_in_current_state:
    "No se puede editar la reserva en el estado actual",
  Err_booking_can_not_be_rescheduled_in_current_state:
    "No se puede reprogramar la reserva en el estado actual",
  Err_booking_date_in_past: "No se puede reservar en una fecha pasada",
  Err_booking_does_not_exist: "La reserva no existe",
  Err_booking_status_change:
    "No se puede realizar esta acción en el estado actual",
  Err_booking_type_requires_access_point:
    "Se requiere seleccionar un punto de acceso",
  Err_can_not_reschedule_recurring:
    "No se pueden reprogramar reservas recurrentes",
  Err_cant_assign_owner_role:
    "No se puede asignar el rol de propietario a otro usuario",
  Err_cant_book_after_advanced_date:
    "No se puede reservar después de la fecha límite",
  Err_cant_book_before_advanced_date:
    "No se puede reservar antes de la fecha permitida",
  Err_cant_change_own_status_but_cancel:
    "No puedes cambiar el estado de la reserva. Solo puedes cancelarla",
  Err_cant_move_booking: "No se puede cambiar la fecha/hora",
  Err_comment_required: "El comentario es obligatorio",
  Err_company_missing: "Falta la información de la empresa",
  Err_contact_required: "El contacto es obligatorio",
  Err_date_range_not_match_booking_numbers:
    "El rango de fechas no coincide con los números de reserva",
  Err_date_required: "La fecha es obligatoria",
  Err_daterange_must_have_two_values: "El rango de fechas es obligatorio",
  Err_does_not_exist: "No existe",
  Err_domain_not_allowed: "Este dominio no está permitido",
  Err_domains_already_registered:
    "Este dominio ya está registrado por otra organización",
  Err_duplicate_break:
    "Conflicto con el cierre del sitio (día y hora). Por favor, actualiza",
  Err_duplicate_closure:
    "Conflicto con el cierre del sitio. Por favor, actualiza",
  Err_duplicate_organization_name:
    "Ya existe una organización con este nombre. Elige otro",
  Err_duplicate_site_name: "Ya existe un sitio con este nombre",
  Err_duplicate_user_email: "Ya existe un usuario con este correo electrónico",
  Err_email_body_not_defined: "Debe definirse el cuerpo del correo",
  Err_email_not_found: "Correo no encontrado",
  Err_email_subject_not_defined: "Debe definirse el asunto",
  Err_email_template_not_defined: "Debe definirse la plantilla",
  Err_file_ref_invalid: "Referencia de archivo inválida",
  Err_incomplete_onboarding: "Onboarding incompleto",
  Err_incorrect_user_role: "El usuario no tiene los permisos correctos",
  Err_integration_config_not_found:
    "No se encontró la configuración de integración",
  Err_integration_disconnect_handler_not_defined:
    "No se definió el handler de desconexión en IntegrationEnableHandlers",
  Err_integration_handler_not_defined:
    "No se definió el handler de integración en IntegrationEnableHandlers",
  Err_integration_not_found: "La integración no está habilitada",
  Err_invalid_access_point: "Punto de acceso inválido",
  Err_invalid_access_point_on_resource:
    "El recurso y el punto de acceso seleccionados no son válidos",
  Err_invalid_booking_status: "Estado de reserva inválido",
  Err_invalid_booking_type: "Tipo de reserva inválido",
  Err_invalid_data: "Datos inválidos",
  Err_invalid_project: "Proyecto inválido",
  Err_invalid_project_role: "Rol de proyecto inválido",
  Err_invalid_project_status:
    "Estado inválido. Debe ser [pre-live, active, paused, finished]",
  Err_invalid_region: "Región inválida",
  Err_invalid_role: "Rol inválido",
  Err_invalid_site: "Sitio inválido",
  Err_misconfigured_region: "Configuración de región incorrecta",
  Err_missing_auth_credentials: "Faltan credenciales de autenticación",
  Err_missing_recurring_booking_options:
    "Faltan opciones de reserva recurrente",
  Err_missing_some_required_fields: "Faltan algunos campos obligatorios",
  Err_multi_vehicle_booking_not_supported:
    "Este proyecto no admite múltiples vehículos",
  Err_must_be_access_point: "El objeto debe ser un punto de acceso",
  Err_must_be_resource: "El objeto debe ser un recurso",
  Err_no_access_to_booking_list: "No tienes acceso a la lista de reservas",
  Err_no_booking_dates: "No se encontraron fechas de reserva",
  Err_no_slots_for_access_point_and_Resource:
    "No hay slots disponibles para este punto de acceso y recurso",
  Err_not_multi_vehicle_booking: "No es una reserva de múltiples vehículos",
  Err_not_part_of_any_organization_or_role:
    "No pertenece a ninguna organización o rol",
  Err_null_project_role: "Se esperaba un rol de proyecto pero se recibió NULL",
  Err_num_vehicles_required:
    "Se requiere número de vehículos para reservas múltiples",
  Err_organization_and_role_mismatch: "Organización y rol no coinciden",
  Err_organization_domain_exists: "Ya existe una organización con este dominio",
  Err_common_util_already_exists: "Esta entrada ya existe",
  Err_organization_not_found: "Organización no encontrada",
  Err_owner_email_required: "Se requiere el correo del propietario",
  Err_permission_denied: "Permiso denegado",
  Err_preference_not_exist: "Preferencia no existe",
  Err_procore_auth_code_missing: "Falta el código de autenticación de Procore",
  Err_project_name_already_exists: "El nombre del proyecto ya existe",
  Err_project_not_active_deleted_or_status_not_allowed:
    "El proyecto no está activo o ha sido eliminado",
  Err_project_not_authenticated_for_integration:
    "El proyecto no está autenticado para esta integración",
  Err_project_user_does_not_exist: "El usuario del proyecto no existe",
  Err_provide_one_of_access_point_or_resource:
    "Debes proporcionar access_point o resource, no ambos",
  Err_question_not_exist: "La pregunta no existe",
  Err_recurring_booking_not_supported:
    "Este proyecto no admite reservas recurrentes",
  Err_repeat_monthly_option_missing:
    "Falta FIRST o LAST en repeat_monthly_option",
  Err_repeat_option_missing: "Falta opción semanal o mensual en repeat_option",
  Err_repeat_weekdays_expects_single_day:
    "repeat_weekdays debe contener solo un día en opción mensual",
  Err_repeat_weekdays_missing:
    "repeat_weekdays debe ser uno de [L, M, X, J, V, S, D]",
  Err_require_one_of_access_point_or_resource:
    "Debes seleccionar un punto de acceso o un recurso",
  Err_required_project_param: "Se requiere información del proyecto",
  Err_required_region_or_project: "Se requiere región o proyecto",
  Err_reserved_slot_expired_or_used: "El slot ha expirado o ya fue usado",
  Err_resource_closure_not_found: "No se encontró el cierre del recurso",
  Err_resource_not_operational: "El recurso no está configurado para operación",
  Err_resource_only_booking_not_supported:
    "No se admiten reservas solo de recursos",
  Err_resource_required: "El recurso es obligatorio",
  Err_resource_required_for_resource_only:
    "No se reservó el recurso para este slot",
  Err_resource_site_mismatch: "El recurso no coincide con el sitio",
  Err_resource_timeing_not_found: "No se encontró horario del recurso",
  Err_site_access_point_mismatch: "El punto de acceso no pertenece al sitio",
  Err_site_does_not_exists: "El sitio no existe",
  Err_site_resource_mismatch: "El recurso no pertenece al sitio",
  Err_slot_not_available: "El slot no está disponible o ya fue usado",
  Err_slot_not_reserved_for_booking_type:
    "El slot no está reservado para este tipo",
  Err_slot_uuid_not_found: "No se encontró el UUID del slot",
  Err_some_feature_actions_are_not_supported:
    "Algunas acciones no están soportadas",
  Err_start_date_greater_than_end: "La fecha de inicio debe ser anterior",
  Err_start_end_date_required: "Se requieren fecha inicio y fin",
  Err_start_time_greater_than_end: "La hora de inicio debe ser anterior",
  Err_unknown_response_from_external_api:
    "Respuesta desconocida del API externo",
  Err_unsupported_export_format: "Formato de exportación no soportado",
  Err_user_already_onboarded: "El usuario ya está registrado o no fue invitado",
  Err_user_does_not_exist: "El usuario no existe",
  Err_user_has_no_access: "El usuario no tiene acceso",
  Err_user_inactive: "El usuario está inactivo",
  Err_user_invalid_token: "Token contiene ID inválido",
  Err_user_not_found: "Usuario no encontrado",
  Err_user_project_role_not_exists: "El rol del usuario no existe",
  Err_username_not_set: "Debe establecerse el nombre de usuario",
  Err_uuid_reserved_another_slot: "UUID usado para otro slot",
  Err_uuid_used_create_another: "UUID ya usado, crea otro",
  Err_vehicle_not_exist: "Vehículo no existe",
  Err_vehicle_type_required: "Tipo de vehículo requerido",
  Msg_booking_field_created_success:
    "Campo de reserva creado/actualizado correctamente",
  Msg_user_remove_from_project: "Usuario eliminado del proyecto",
  Msg_users_invited_success: "Usuarios invitados correctamente",
  "Not Found": "No encontrado",
  email_optional: "Correo electrónico (opcional)",
  copied: "Copiado",
  Checkout: "Salida",
  Refuse: "Rechazar",
  override_constraints: "No aplicar esta configuración a administradores",
  override_constraints_tooltip:
    "Permite a administradores crear reservas ignorando restricciones",
  region_state: "Provincia/Estado",
  error_organizationState_required: "El estado es obligatorio",
  disable: "Deshabilitar",
  core_features: "Funciones principales",
  pro_features: "Funciones Pro",
  invite_canceled: "Invitación cancelada",
  invite_resend: "Invitación reenviada",
  cant_move_booking_across: "No se puede cambiar la fecha de la reserva",
  accesspoint: "Punto de acceso",
  project_settings_updated: "Configuración actualizada",
  Expired: "Expirado",
  column_config_new: "Crear nuevo diseño",
  column_config_name: "Nombre del diseño",
  column_config_are_you_sure: "¿Seguro que deseas eliminar este diseño?",
  column_config_delete: "Eliminar",
  set_default: "Establecer como predeterminado",
  set_default_tooltip: "Solo administradores",
  column_config_created: "Diseño creado",
  column_config_updated: "Diseño actualizado",
  column_config_deleted: "Diseño eliminado",
  column_config_cannot_be_changed: "No se puede modificar",
  Status: "Estado",
  Resource: "Recurso",
  "Booking Ref": "Referencia de reserva",
  "Arrival Date": "Fecha de llegada",
  "Arrival Time": "Hora de llegada",
  "Departure Time": "Hora de salida",
  "Access Point": "Punto de acceso",
  "Vehicle type": "Tipo de vehículo",
  "Contact Company": "Empresa de contacto",
  reinstate_booking: "Restaurar",
  reinstate_booking_are_you_sure: "¿Restaurar esta reserva?",
  error_more_than_year_in_advance: "Introduce un número menor o igual a 365",
  only_available: "Solo disponibles",
  only_booked: "Solo reservados",
  all_resource: "Todos los recursos",
  invite_link_cancelled_desc:
    "El enlace ha expirado. Contacta al administrador",
  invite_link_cancelled: "Enlace expirado",
  any_integration_lost: "Integración reiniciada",
  undefined: "Lunes",
  no_trade_type: "Sin tipo de operación",
  select_platform: "Seleccionar plataforma",
  invalid_postal_code: "Código postal inválido",
  enter_postal_code: "Introduce código postal",
  equipment_management: "Gestión de equipos",
  analytics: "Analítica",
  None: "Ninguno",
  "Existing Building Demolition": "Demolición de edificio existente",
  "CIP concrete, precast concrete, rebar":
    "Hormigón CIP, prefabricado y acero de refuerzo",
  CMU: "CMU",
  "Structural Steel Framing, Steel Decking, Cold Formed Metal Framing":
    "Estructura de acero, losa metálica, metal conformado en frío",
  "Rough carpentry": "Carpintería estructural",
  "Thermal insulation for GWB assemblies and roofing, roofing and siding panels, membrane roofing":
    "Aislamiento térmico, techado y paneles",
  "Doors, Frames, Hardware, Interior and Exterior Glazing, Specialty Doors":
    "Puertas, marcos, herrajes y vidrio",
  "GWB assemblies, paint & coatings, flooring, acoustical ceilings":
    "GWB, pintura, pisos y techos acústicos",
  "Site concrete and asphalt paving":
    "Hormigón del sitio y pavimentación asfáltica",
  "Earthwork & utilities": "Movimiento de tierras y servicios públicos",
  "Temporary Construction": "Construcción temporal",
  "Frame construction": "Construcción de estructura",
  "Finishing construction": "Construcción de acabados",
  "Equipment construction": "Construcción de equipos",
  "Miscellaneous construction": "Construcción miscelánea",

  // Trade Type Filter
  existing_building_demolition: "Demolición de edificio existente",
  cip_concrete__precast_concrete__rebar:
    "Hormigón CIP, hormigón prefabricado, acero de refuerzo",
  cmu: "CMU",
  structural_steel_framing__steel_decking__cold_formed_metal_framing:
    "Estructura de acero, losa metálica, estructura metálica conformada en frío",
  rough_carpentry: "Carpintería en bruto",
  thermal_insulation_for_gwb_assemblies_and_roofing__roofing_and_siding_panels__membrane_roofing:
    "Aislamiento térmico para ensamblajes GWB y techado, paneles de techado y revestimiento, techado con membrana",
  doors__frames__hardware__interior_and_exterior_glazing__specialty_doors:
    "Puertas, marcos, herrajes, acristalamiento interior y exterior, puertas especiales",
  gwb_assemblies__paint_and_coatings__flooring__acoustical_ceilings:
    "Ensamblajes GWB, pintura y recubrimientos, pisos, techos acústicos",
  site_concrete_and_asphalt_paving:
    "Hormigón del sitio y pavimentación asfáltica",
  earthwork_and_utilities: "Movimiento de tierras y servicios públicos",
  temporary_construction_work: "Construcción temporal",
  frame_construction: "Construcción de estructura",
  finishing_construction: "Construcción de acabados",
  equipment_construction: "Construcción de equipos",
  miscellaneous_construction: "Construcción miscelánea",

  fuel_type: "Tipo de combustible",
  Level: "Nivel",
  eta: "Hora estimada de llegada",
  bulk_upload_errors: "Errores de carga masiva",
  upload_summary: "Resumen de carga",
  total_records: "Total de registros",
  successful_records: "Registros exitosos",
  failed_records: "Registros fallidos",
  download_errors: "Descargar errores",
  error_details: "Detalles del error",
  slot_updated_successfully: "El turno se actualizó correctamente",
  slot_update_failed: "No se pudo actualizar el turno",
  "Number Of Vehicles": "Número de vehículos",
  number_of_vehicles: "Número de vehículos",
  Postcode: "Código postal",
  postcode: "Código postal",
  Zipcode: "Código postal",
  zipcode: "Código postal",
  Distance: "Distancia",
  distance: "Distancia",
  Country: "País",
  State: "Estado",
  state: "Estado",
  Materials: "Materiales",
  materials: "Materiales",
  Material: "Material",
  material: "Material",
  "Material information": "Información del material",
  material_information: "Información del material",
  Submittal: "Entrega",
  submittal: "Entrega",
  Submittals: "Entregas",
  submittals: "Entregas",
  "First Delivery": "Primera entrega",
  first_delivery: "Primera entrega",
  "Submittal doc": "Documento de entrega",
  submittal_doc: "Documento de entrega",
  "Delivery Document": "Documento de entrega",
  delivery_document: "Documento de entrega",
  "H&S Declaration": "Declaración de S&S",
  h_s_declaration: "Declaración de S&S",
  "H&S Policy": "Política de S&S",
  h_s_policy: "Política de S&S",
  "Loading/Unloading": "Carga/Descarga",
  loading_unloading: "Carga/Descarga",
  "ID Reference": "Referencia ID",
  id_reference: "Referencia ID",
  "First Visit": "Primera visita",
  first_visit: "Primera visita",
  checkout_time_must_be_after_checkin:
    "La hora de salida debe ser posterior a la de entrada",
  checkin_time_must_be_before_checkout:
    "La hora de entrada debe ser anterior a la de salida",
  Err_cant_set_future_date_time:
    "No se puede establecer una fecha y hora futura",
  vehicle_restrictions: "Restricciones de vehículos",
  vehicle_restrictions_tooltip:
    "Utilice las restricciones de vehículos para limitar el acceso a fechas específicas o puntos de acceso. Por ejemplo, restringir vehículos en días festivos o bloquear indefinidamente el acceso a una puerta.",
  Err_vehicle_restricted_for_access_point:
    "El vehículo seleccionado está restringido en este punto de acceso",
  Err_unconditional_restriction_exists:
    "Ya existe una restricción incondicional para este vehículo en el punto de acceso seleccionado",
  list_of_equipment: "Lista de equipos",
  regModel: "Registro: modelo",
  regMake: "Registro: fabricante",
  equipment_type: "Tipo de equipo",
  contact: "Contacto",
  scheduled_arrivals: "Llegadas programadas",
  regYear: "Registro: año",
  regUsage: "Registro: uso",
  regOtherUsage: "Registro: otro uso",
  reference: "Referencia",
  details_of_individual_responsible_for_equipment:
    "Detalles de la persona responsable del equipo",
  register_equipment: "Registrar equipo",
  add_equipment_type: "Agregar tipo de equipo",
  equipment_master: "Maestro de equipos",
  equipment_master_add: "Agregar equipo",
  equipment_master_copy: "Copiar equipo desde maestro",
  equipment_master_edit: "Editar equipo",
  equipment_master_delete: "Eliminar equipo",
  equipment_usage_add: "Agregar uso de equipo",
  clear_filters: "Limpiar filtros",
  equipment_usage_edit: "Editar uso de equipo",
  equipment_usage_delete: "Eliminar uso de equipo",
  equipment_usage_add_success: "Uso de equipo agregado correctamente",
  equipment_usage_edit_success: "Uso de equipo actualizado correctamente",
  equipment_usage_delete_success: "Uso de equipo eliminado correctamente",
  equipment_usage_report_download_success: "Informe descargado correctamente",
  equipment_master_delete_confirmation:
    "¿Está seguro de que desea eliminar este equipo?",
  no_equipment_found: "No se encontraron equipos",
  equipment_master_delete_success: "Equipo eliminado correctamente",
  equipment_master_add_success: "Equipo agregado correctamente",
  equipment_master_edit_success: "Equipo actualizado correctamente",
  equipment_master_copy_success: "Equipo copiado correctamente",
  equipment_master_name: "Nombre",
  equipment_master_category: "Categoría",
  equipment_master_brand: "Marca",
  equipment_master_model: "Modelo",
  equipment_master_factor: "Factor",
  equipment_master_name_required: "El nombre es obligatorio",
  equipment_master_category_required: "La categoría es obligatoria",
  equipment_master_brand_required: "La marca es obligatoria",
  equipment_master_model_required: "El modelo es obligatorio",
  equipment_master_factor_required: "El factor es obligatorio",
  equipment_master_factor_invalid: "El factor debe ser un número",
  equipment_master_factor_range: "El factor debe estar entre 0 y 1",
  equipment_master_factor_range_invalid:
    "El factor debe ser un número entre 0 y 1",
  equipment_master_factor_range_invalid_2:
    "El factor debe ser un número entre 0 y 1",
  equipment_master_factor_range_invalid_3:
    "El factor debe ser un número entre 0 y 1",
  equipment_master_factor_range_invalid_4:
    "El factor debe ser un número entre 0 y 1",
  list_equipments: "Lista de equipos",
  equipment_usage: "Uso de equipo",
  vehicle_master_add: "Agregar vehículo",
  vehicle_master_edit: "Editar vehículo",
  vehicle_master: "Maestro de vehículos",
  vehicle_master_delete: "Eliminar vehículo",
  vehicle_master_copy: "Copiar vehículo desde maestro",
  copy_from_master: "Copiar desde maestro",
  vehicle_master_delete_confirmation:
    "¿Está seguro de que desea eliminar este vehículo?",
  vehicle_master_delete_success: "Vehículo eliminado correctamente",
  vehicle_master_add_success: "Vehículo agregado correctamente",
  vehicle_master_edit_success: "Vehículo actualizado correctamente",
  vehicle_master_name: "Nombre",
  vehicle_master_category: "Categoría",
  vehicle_master_brand: "Marca",
  vehicle_master_model: "Modelo",
  vehicle_master_factor: "Factor",
  vehicle_master_name_required: "El nombre es obligatorio",
  vehicle_master_category_required: "La categoría es obligatoria",
  vehicle_master_brand_required: "La marca es obligatoria",
  vehicle_master_model_required: "El modelo es obligatorio",
  vehicle_master_factor_required: "El factor es obligatorio",
  vehicle_master_factor_invalid: "El factor debe ser un número",
  vehicle_master_factor_range: "El factor debe estar entre 0 y 1",
  vehicle_master_factor_range_invalid:
    "El factor debe ser un número entre 0 y 1",
  vehicle_emission_add: "Agregar emisiones del vehículo",
  vehicle_emission_edit: "Editar emisiones",
  vehicle_emission: "Emisiones del vehículo",
  vehicle_emission_delete: "Eliminar emisiones",
  vehicle_emission_delete_confirmation:
    "¿Está seguro de que desea eliminar esta emisión?",
  vehicle_emission_delete_success: "Las emisiones se eliminaron correctamente",
  vehicle_emission_add_success: "Las emisiones se agregaron correctamente",
  vehicle_emission_edit_success: "Las emisiones se actualizaron correctamente",
  vehicle_emission_copy_success: "Las emisiones se copiaron correctamente",
  vehicle_emission_approve_success: "Emisión aprobada correctamente",
  vehicle_emission_reject_success: "Emisión rechazada correctamente",
  vehicle_emission_name: "Nombre",
  milesgallons_or_kmLitres: "Millas/galón o kilómetros/litro",
  temp_emission_factor: "Factor de emisión de temperatura",
  vendor: "Proveedor",
  roundtrip_distance_delivered_from_jobsite:
    "Distancia de ida y vuelta desde el sitio de trabajo",
  type_of_vehicle: "Tipo de vehículo",
  vehicle_mpg: "Consumo del vehículo (si está disponible)",
  vehicle_kmpl: "KMPL del vehículo (si está disponible)",
  round_trip_vehicle_coefficient: "Coeficiente de vehículo ida y vuelta",
  round_trip_co2_emissions: "Emisiones de CO2 ida y vuelta (toneladas)",
  one_way_trip_distance: "Distancia de un solo trayecto",
  one_way_trip_vehicle_coefficient:
    "Coeficiente de vehículo de un solo trayecto",
  one_way_trip_co2_emissions:
    "Emisiones de CO2 de un solo trayecto (toneladas)",
  summary_emissions_report: "Resumen de emisiones",
  vehicle_emission_reports: "Emisiones de vehículos",
  equipment_and_vehicle_emissions: "Emisiones de equipos y vehículos",
  environment_reports: "Informes ambientales",
  emission_settings: "Configuración de emisiones",
  emission_settings_details: "El seguimiento de emisiones estará habilitado",
  transport_round_trip: "Transporte ida y vuelta",
  transport_round_trip_settings: "Configuración de transporte ida y vuelta",
  transport_round_trip_details:
    "Se realizará seguimiento del transporte ida y vuelta",
  equipment_monthly_usage_capture: "Captura de uso mensual de equipos",
  add_equipment_monthly_usage_capture: "Agregar uso de equipos",
  equipment_name: "Nombre del equipo",
  equipment_category: "Categoría del equipo",
  equipment_brand: "Marca del equipo",
  equipment_model: "Modelo del equipo",
  equipment_quantity: "Cantidad de equipos",
  equipment_arrival_date: "Fecha de llegada del equipo",
  emission_factor: "Factor de emisión",
  recepient_name: "Nombre del destinatario",
  uploaded: "Subido",
  download: "Descargar",
  model: "Modelo",
  mobile_number: "Número móvil",
  equipment_registration: "Registro de equipo",
  registration: "Registro",
  year_of_manufacture: "Año de fabricación",
  make_of_the_equipment: "Fabricante del equipo",
  type_of_usage: "Tipo de uso",
  global_settings: "Configuración global",
  country_uom: "Unidad de medida del país",
  country_uom_add: "Agregar unidad de país",
  country_uom_edit: "Editar unidad de país",
  country_uom_add_success: "Unidad de país agregada correctamente",
  country_uom_edit_success: "Unidad de país actualizada correctamente",
  country_uom_delete_success: "Unidad de país eliminada correctamente",
  distance_uom: "Unidad de distancia",
  volume_uom: "Unidad de volumen",
  weight_uom: "Unidad de peso",
  Actions: "Acciones",
  actions: "Acciones",
  type: "Tipo",
  commonUtil_master: "Maestro de utilidades comunes",
  commonUtil_master_add: "Agregar utilidad común",
  commonUtil_master_edit: "Editar utilidad común",
  commonUtil_delete_success: "Utilidad común eliminada correctamente",
  msg_arrival_date_is_required: "La fecha de llegada es obligatoria",
  msg_equipment_type_is_required: "El tipo de equipo es obligatorio",
  msg_company_name_is_required: "El nombre de la empresa es obligatorio",
  msg_invalid_email_address: "Dirección de correo electrónico inválida",
  msg_equipment_make_is_required: "El fabricante del equipo es obligatorio",
  msg_equipment_model_is_required: "El modelo del equipo es obligatorio",
  msg_year_of_manufacture_is_required: "El año de fabricación es obligatorio",
  if_selected_other:
    'Si selecciona "Otro" en tipo de equipo, proporcione detalles',
  fuel_type_required: "El tipo de combustible es obligatorio",
  type_of_usage_required: "El tipo de uso es obligatorio",
  date_of_equipment_arrival: "Fecha de llegada del equipo",
  environment_setting: "Configuración ambiental",
  activity_type: "Tipo de actividad",
  reporting_month: "Mes de informe",
  sub_activity: "Subactividad",
  needed_equipment: "Equipo necesario",
  days_on_site: "Días en el sitio",
  hours_use: "Horas de uso",
  fuel_efficiency: "Eficiencia de combustible",
  total_fuel_use: "Uso total de combustible",
  of_total_co2_emissions: "del total de emisiones de CO2",
  total_co2_footprint: "Huella total de CO2",
  co2_footprint: "Huella de CO2",
  co2_emissions: "Emisiones de CO2",
  duplicate_equipment_registry:
    "Ya existe un registro de equipo con estos detalles",
  equipment_registry_add_success: "Equipo registrado correctamente",
  equipment_registry_edit_success:
    "Registro de equipo actualizado correctamente",
  invalid_zipcode: "Ingrese un código postal válido",
  err_zipcode_required:
    "El código postal es obligatorio y no puede estar vacío",
  "Equipment Analytics Admin": "Administrador de análisis de equipos",
  equipment_analytics_admin: "Administrador de análisis de equipos",
  "Environment User": "Usuario ambiental",
  environment_user: "Usuario ambiental",
  "Environment Admin": "Administrador ambiental",
  environment_admin: "Administrador ambiental",
  Subcontractor: "Subcontratista",
  subcontractor: "Subcontratista",
  "Supplier Equipment Coordinator": "Coordinador de equipos del proveedor",
  supplier_equipment_coordinator: "Coordinador de equipos del proveedor",
  emission_already_exists:
    "Ya existen emisiones para este tipo de vehículo y combustible",
  vehicle_type_is_required: "El tipo de vehículo es obligatorio",
  fuel_type_is_required: "El tipo de combustible es obligatorio",
  vehicle_or_fuel_type_not_found:
    "No se encontró el vehículo o tipo de combustible",
  Err_vehicle_fuel_type_combination_not_found:
    "No se encontraron emisiones para la combinación de vehículo y combustible",
  Err_number_of_vehicles_only_for_multi_vehicle_bookings:
    "El número de vehículos solo se puede establecer para reservas de múltiples vehículos",
  year: "Año",
  month: "Mes",
  search: "Buscar",
  Search: "Buscar",
  equipment_reference: "Referencia de equipo",
  no_of_hours: "Número de horas",
  litres: "Litros",
  gallons: "Galones",
  KMPL: "KMPL",
  MPG: "MPG",
  km: "Kilómetros",
  miles: "Millas",
  location: "Ubicación",
  vehicle_registration: "Registro del vehículo",
  vehicle_make: "Marca del vehículo",
  vehicle_model: "Modelo del vehículo",
  subtotal: "Subtotal",
  performance_by_recipient: "Rendimiento por destinatario",
  deliveries: "Entregas",
  total_distance: "Distancia total",
  avg_distance: "Distancia promedio",
  total_co2: "CO2 total",
  efficiency_score: "Puntuación de eficiencia",
  rank: "Clasificación",
  distance_by_vehicle_type: "Distancia por tipo de vehículo",
  co2_emission_by_vehicle_type: "Emisiones de CO2 por tipo de vehículo",
  distance_trendes: "Tendencias de distancia",
  co2_emission_trendes: "Tendencias de emisiones de CO2",
  duration: "Duración",
  co2: "CO2",
  average_distance: "Distancia promedio",
  average_co2: "CO2 promedio",
  total_trips: "Total de viajes",
  trade_types: "Tipos de trabajo",
  default: "Predeterminado",
  default_view: "Vista predeterminada",
  select_all: "Seleccionar todo",
  delselect_all: "Deseleccionar todo",
  co2_footprint_short_tons: "Huella de CO2 (toneladas cortas)",
  total_co2_footprint_metric_tons: "Huella total de CO2 (toneladas métricas)",
  Default: "Predeterminado",
  "Default View": "Vista predeterminada",
  "Select All": "Seleccionar todo",
  "Deselect All": "Deseleccionar todo",
  deselect_all: "Deseleccionar todo",
  "CO2 Footprint (short tons)": "Huella de CO2 (toneladas cortas)",
  "Total CO2 Footprint (metric tons)":
    "Huella total de CO2 (toneladas métricas)",
  total_co2_footprint_short_tons: "Huella total de CO2 (toneladas cortas)",
  "of Total CO2 Emissions": "del total de emisiones de CO2",
  "Emission Factor": "Factor de emisión",
  "Trade Type": "Tipo de trabajo",
  "Trade Types": "Tipos de trabajo",
  search_month_activity_equipment:
    "Buscar por mes, actividad, equipo, tipo de combustible, etc.",
  search_by_vendor_material_vehicle_type:
    "Buscar por proveedor, material, tipo de vehículo, etc.",
  vehicle_restriction_updated:
    "Restricción de vehículo actualizada correctamente",
  error_fetching_vehicle_types: "Error al obtener los tipos de vehículos",
  error_missing_project_ref: "Falta la referencia del proyecto",
  error_fetching_restrictions:
    "Error al obtener las restricciones de vehículos",
  error_removing_restriction: "Error al eliminar la restricción de vehículo",
  error_validation_failed: "La validación falló",
  unconditional_restriction_exists:
    "Ya existe una restricción incondicional para este vehículo en el punto de acceso seleccionado",
  cannot_create_unconditional:
    "No se puede crear una restricción incondicional si existen restricciones basadas en fechas para el mismo vehículo y punto de acceso",
  date_range_overlap:
    "El rango de fechas se superpone con una restricción existente",
  vehicle_restriction_duplicate:
    "Ya existe una restricción de vehículo para el rango de fechas, punto de acceso y vehículo seleccionados",
  invalid_restriction_id: "ID de restricción inválido",
  Err_start_date_required: "La fecha de inicio es obligatoria",
  manage_vehicle_restrictions: "Gestionar restricciones de vehículos",
  start_date: "Fecha de inicio",
  end_date: "Fecha de fin",
  value_must_be_greater_than_zero: "El valor debe ser mayor que cero",
  mark_as_read: "Marcar como leído",
  // System Banner Error Messages
  Err_system_banner_mark_as_read_failed:
    "No se pudo marcar el banner como leído",
  Err_system_banner_mark_as_read_error: "Error al marcar el banner como leído",
  error_fetching_banners: "Error al obtener los banners del sistema",
  total_notifications: "Notificaciones",
  notification_center: "Centro de notificaciones",
  notification_type: "Tipo",
  notification_title: "Título",
  notification_description: "Descripción",
  notification_date: "Fecha",
  notification_priority: "Prioridad",
  notification_status: "Estado",
  notification_actions: "Acciones",
  notification_no_notifications: "No hay notificaciones",
  notification_mark_as_read: "Marcar como leído",
  notification_mark_as_unread: "Marcar como no leído",
  notification_deleted: "Notificación eliminada",
  notification_marked_as_read: "Notificación marcada como leída",
  notification_marked_as_unread: "Notificación marcada como no leída",
  delete: "Eliminar",
  read: "Leído",
  unread: "No leído",
  mark_as_unread: "Marcar como no leído",
  push_notifications: "Notificaciones push",
  not_supported_in_browser: "Este navegador no admite notificaciones push",
  push_notifications_unavailable:
    "Las notificaciones push no están disponibles actualmente",
  push_notifications_not_enabled:
    "Las notificaciones push no están habilitadas",
  notifications: "Notificaciones",
  err_getting_unread_count:
    "Error al obtener el número de notificaciones no leídas",
  push_notification_updated: "Configuración de notificaciones push actualizada",
  push_notifications_enabled: "Las notificaciones push están habilitadas",
  date_field_required: "El campo de fecha es obligatorio",
};
export default Translation;
